import { Treatment } from './types';
import { EXPERIMENT_IDENTIFIERS } from '~server/routes/Pricing/experimentsConfig';

const Treatments: Treatment = {
  ENTERPRISE_FEATURES_GP69: EXPERIMENT_IDENTIFIERS.ENTERPRISE_FEATURES_GP69.treatment,
  GROW_2427_TREATMENT: EXPERIMENT_IDENTIFIERS.GROW_2427.treatment,
  GROW_2529_FORMS_TREATMENT1: EXPERIMENT_IDENTIFIERS.GROW_2529_FORMS.treatment1,
  GROW_2529_FORMS_TREATMENT2: EXPERIMENT_IDENTIFIERS.GROW_2529_FORMS.treatment2,
  GROW_2629_FORMS_V2_TREATMENT: EXPERIMENT_IDENTIFIERS.GROW_2629_FORMS_V2.treatment,
};

export default Treatments;
